import { isEmpty } from 'lodash';
import { uploadImage } from 'redux/actions/messageActions';
import { ERROR_5XX_TOASTER, MAX_FILE_SIZE_ERROR } from 'constants/errors';
import { MAX_FILE_SIZE } from 'constants/misc';

// eslint-disable-next-line
export const getMessageFromDisplayName = (email, senderName) => (isEmpty(senderName) ? email : senderName);

export const getLastMsg = outreach => (outreach.last_message ?
  outreach.last_message : outreach);


export const uploadUserImage = async (delta, source, editor, setUploading) => {
  if (source === 'user') {
    const allDeltas = editor.getContents();
    for (let i = 0; i < delta.ops.length; i += 1) {
      // if user is trying to insert image
      if (delta.ops[i].insert && delta.ops[i].insert.image) {
        // then check all deltas if they have image as base64 image which needs to be send to server
        for (let ii = 0; ii < allDeltas.ops.length; ii += 1) {
          const op = allDeltas.ops[ii];
          if (op.insert && op.insert.image && op.insert.image.includes('base64')) {
            let response = null;
            const { size: imgSize } = new Blob([allDeltas.ops[ii].insert.image]);
            if (imgSize > MAX_FILE_SIZE) {
              allDeltas.ops[ii].insert = {};
              return { allDeltas, error: new Error(MAX_FILE_SIZE_ERROR) };
            }
            setUploading(true);
            try {
              // eslint-disable-next-line no-await-in-loop
              response = await uploadImage({ fileBase64: allDeltas.ops[ii].insert.image });
            } catch (e) {
              allDeltas.ops[ii].insert = {};
              const error = new Error(ERROR_5XX_TOASTER);
              error.log = true;
              return { allDeltas, error };
            }
            allDeltas.ops[ii].insert = {
              image: response.file_url,
              attributes: {
                // TODO: this doesn't work
                // in theory it should set image height thus preventing image from resizing container when image
                // isn't loaded, so browser can't determine it's height
                height: response.height,
                width: response.width,
              },
            };
            return { allDeltas, error: null };
          }
        }
      }
    }
  }
  return { allDeltas: null, error: null };
};

// TODO
// - simplify this function
// - Wrap react quill to handle uploadUserImage
